import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_929_2347)">
        <path
          d="M1.33337 14.6667H14.6667"
          stroke="#637381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66663 14.6666V4.50073C2.66663 4.08456 2.66663 3.87648 2.77864 3.70926C2.89065 3.54203 3.09237 3.44898 3.49581 3.26286L6.49581 1.87888C7.46876 1.43003 7.95523 1.20561 8.31089 1.40844C8.66663 1.61127 8.66663 2.1131 8.66663 3.11675V14.6666"
          stroke="#637381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 14.6667V7.49081C13.3333 7.08988 13.3333 6.88942 13.2172 6.72828C13.101 6.56718 12.8918 6.47753 12.4734 6.29822L8.66663 4.66675"
          stroke="#637381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6H6.33333M5 8.66667H6.33333M5 11.3333H6.33333"
          stroke="#637381"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_929_2347">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
